import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { getAllBrasilStates } from "~/utils/advanceRequest";
import { useAutoApplyFilters } from "~/shared/ui/filters/useAutoApplyFilters";

const STATES = getAllBrasilStates();
const DEFAULTS = { fullName: "", email: "", crm: "", crmUf: "", cpf: "" };
const TEXT_FIELDS = ["fullName", "email", "crm", "cpf"];

// Decisão U1: aplica sozinho (UF 300 ms, texto 400 ms ou Enter); sem "Aplicar filtros".
export default function FilterBarDoctors({ onFilterChange }) {
  const { draft, setField, bindText, flush, clear, hasActive } = useAutoApplyFilters({
    value: DEFAULTS,
    defaults: DEFAULTS,
    onApply: (next) => onFilterChange?.(next),
    textFields: TEXT_FIELDS,
  });
  return (
    <Box
      component="form"
      role="search"
      aria-label="Filtros dos médicos"
      noValidate
      onSubmit={(e) => {
        e.preventDefault();
        flush();
      }}
    >
      <Box sx={{ display: "grid", gap: 1.5, gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))", alignItems: "center" }}>
        <TextField label="Nome do Médico" {...bindText("fullName")} />
        <TextField label="Email" {...bindText("email")} />
        <TextField label="CRM" {...bindText("crm")} inputProps={{ inputMode: "numeric" }} />
        <TextField select label="CRMUF" value={draft.crmUf} onChange={(e) => setField("crmUf", e.target.value)}>
          <MenuItem value="">Todas</MenuItem>
          {STATES.map((s) => <MenuItem key={s.uf} value={s.uf}>{s.name}</MenuItem>)}
        </TextField>
        <TextField label="CPF" {...bindText("cpf")} inputProps={{ inputMode: "numeric" }} />
      </Box>
      {hasActive && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1.5 }}>
          <Button type="button" onClick={clear}>Limpar filtros</Button>
        </Box>
      )}
    </Box>
  );
}
